// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertMessageSelectorTemplate from '@front/templates/CreateAlertMessageSelectorTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { AlertType } from '@shared/utils/Alert/AlertConstants';
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
import { AlertUtils } from '@shared/utils/Alert/AlertUtils';
import { WDSettings } from '@front/controls/settings/WDGeneralSettings';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertMessageSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.CreateAlertMessageSelector;
    }
    oninit() {
        super.oninit();
        super.observe('account instrument alertType alertCondition alertValue', this.updateAlertMessageText);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateAlertMessageText() {
        const instrument = super.get('instrument');
        if (instrument == null) {
            return;
        }
        const msgTxt = AlertUtils.GetMessageText(instrument, super.get('alertType'), super.get('alertCondition'), this.getAlertValueFormatted(), super.get('account'));
        void super.set('messageText', msgTxt);
    }
    getAlertValueFormatted() {
        const instrument = super.get('instrument');
        if (instrument == null) {
            return '';
        }
        const alertType = super.get('alertType');
        const value = super.get('alertValue');
        let formattedValue = '';
        if (alertType === AlertType.CHANGE) {
            formattedValue = value.toFixed(2);
        }
        else if (alertType === AlertType.VOLUME) {
            formattedValue = instrument.DataCache.formatVolume(instrument, value, null, WDSettings.productType, super.get('account'));
        }
        else {
            formattedValue = instrument.formatPrice(value);
        }
        return formattedValue;
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void super.set('label', Resources.getResource('screen.Alerts.Message'));
        void super.set('placeholder', Resources.getResource('screen.Alerts.Button.Create.Tooltip'));
    }
}
ContainerControl.extendWith(CreateAlertMessageSelector, {
    template: CreateAlertMessageSelectorTemplate,
    data: function () {
        return {
            label: '',
            messageText: '',
            placeholder: '',
            isMessageTextValid: true
        };
    }
});
